module.exports = __webpack_public_path__ + "static/tiefling_fighter-75db3656daf5ea6aa63eaec8a8b94854.png";